<template>
    <el-dialog :before-close="close" :title="title" :visible.sync="dialog.visible" width="400px">
        <el-form :model="form" label-width="60px">
            <el-form-item label="用户名">
                <el-input v-model="form.name" />
            </el-form-item>
            <el-form-item label="手机号">
                <el-input :disabled="dialog.type === DIALOG_EDIT" v-model="form.mobile" />
            </el-form-item>
            <el-form-item label="角色">
                <el-radio-group v-model="form.role">
                    <el-radio
                        :key="item.value"
                        :label="item.value"
                        v-for="item in ROLE"
                    >{{ item.label }}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button @click="handle" type="primary">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { api, post } from '../../service';
import { DIALOG, DIALOG_EDIT, DIALOG_ADD, ROLE } from '../../libs/enum.js';

const { mapState, mapActions } = createNamespacedHelpers('user');

export default {
    data() {
        return {
            DIALOG_EDIT,
            ROLE,
        };
    },
    computed: {
        ...mapState({
            dialog: state => state.dialog,
            form: state => state.form,
        }),
        title() {
            return `${DIALOG[this.dialog.type]}用户`;
        },
    },
    methods: {
        ...mapActions(['changeDialog', 'addUser', 'editUser']),
        close() {
            this.changeDialog({ visible: false, type: DIALOG_ADD });
        },
        handle() {
            this.dialog.type === DIALOG_ADD ? this.addUser() : this.editUser();
        },
    },
};
</script>
